<div class="d-flex justify-content-center">
	<img src="/assets/no-data.jpg" alt="" style="width:100%; height:70%" />
</div>
<div class="justify-content-center">
	<h3 class="text-center">
		No previous issue data found for this vehicle..!
	</h3>
</div>
